import React from "react";
import { SelectableList } from "../SelectableList/SelectableList";
import { ISelectableListItem } from "../../interfaces/Components/SelectableList/ISelectableListItem";
import { useEffect, useCallback, useState } from "react";
import { Button } from "react-bootstrap"
import { ChevronRight, ChevronLeft, ChevronDown, ChevronUp } from "react-bootstrap-icons";
import { ITransferProps } from "../../interfaces/Components/Transfer/ITransferProps";

export const Transfer = ({items, onChange, options } : ITransferProps) => {

    const [sourceList, setSourceList] = useState(items);
    const [availableList, setAvailableList] = useState(new Array<ISelectableListItem>());
    const [selectedList, setSelectedList] = useState(new Array<ISelectableListItem>());

    useEffect(() => {
        setAvailableList(sourceList.filter(i => !i.Selected).map(i=> { return {Checked: false, Key: i.Key, Label: i.Label }}));
        setSelectedList(sourceList.filter(i => i.Selected).map(i=> { return {Checked: false, Key: i.Key, Label: i.Label }}));
    },[sourceList])

    const availableListChangedHandler = useCallback((items: Array<ISelectableListItem>) => {
        setAvailableList(items);
    }, []);

    const selectedListChangedHandler = useCallback((items: Array<ISelectableListItem>) => {
        setSelectedList(items);
    }, []);

    const moveToSelectedHandler = () => {
        let newSourceList = sourceList.slice();
        const keysToMove : Array<string> = availableList.filter(i => i.Checked).map(i => i.Key);
        newSourceList.forEach(i => {
            if(keysToMove.indexOf(i.Key) > -1) {
                i.Selected = true;
            }
        })
        onChange(newSourceList);
        setSourceList(newSourceList);
    }

    const moveToAvailableHandler = () => {
        let newSourceList = sourceList.slice();
        const keysToMove : Array<string> = selectedList.filter(i => i.Checked).map(i => i.Key);
        newSourceList.forEach(i => {
            if(keysToMove.indexOf(i.Key) > -1) {
                i.Selected = false;
            }
        })
        onChange(newSourceList);
        setSourceList(newSourceList);
    }
    
    const moveToSelectedDisabled = availableList.filter(i => i.Checked).length === 0;
    const moveToAvailableDisabled = selectedList.filter(i => i.Checked).length === 0;

    return <div className="d-flex flex-column flex-md-row">
        <div className="flex-fill">
            {(options?.firstListLabel !== "") && <span><strong>{options?.firstListLabel}</strong></span>}
            <SelectableList uniqueName="available-list" items={availableList} onChange={availableListChangedHandler} options={{...options, noResultsMessage: "No available items" }} label={options?.firstListLabel}></SelectableList>
        </div>
        <div className="flex-shrink-1">
            <div className="p-3 h-100">
                <div className="d-flex flex-sm-row flex-md-column h-100 justify-content-center align-items-center">
                	<div className="mt-auto p-1">
		                <Button data-testid="move-right-button" disabled={moveToSelectedDisabled} onClick={moveToSelectedHandler} className="d-none d-md-block" variant={moveToSelectedDisabled ? "secondary" :"primary"} size="lg"><ChevronRight></ChevronRight><span className="visually-hidden">Move to selected list</span></Button>
		                <Button data-testid="move-down-button" disabled={moveToSelectedDisabled} onClick={moveToSelectedHandler} className="d-md-none" variant={moveToSelectedDisabled ? "secondary" :"primary"} size="lg"><ChevronDown></ChevronDown><span className="visually-hidden">Move to selected list</span></Button>
	                </div>
	                <div className="mb-auto p-1">
		                <Button data-testid="move-left-button" disabled={moveToAvailableDisabled} onClick={moveToAvailableHandler} className="d-none d-md-block" variant={moveToAvailableDisabled ? "secondary" :"primary"} size="lg"><ChevronLeft></ChevronLeft><span className="visually-hidden">Move to available list</span></Button>
		                <Button data-testid="move-up-button" disabled={moveToAvailableDisabled} onClick={moveToAvailableHandler} className="d-md-none" variant={moveToAvailableDisabled ? "secondary" :"primary"} size="lg"><ChevronUp></ChevronUp><span className="visually-hidden">Move to available list</span></Button>
	                </div>
                </div>
            </div>
        </div>
        <div className="flex-fill">
            {(options?.secondListLabel !== "") && <span><strong>{options?.secondListLabel}</strong></span>}
            <SelectableList uniqueName="selected-list"items={selectedList} onChange={selectedListChangedHandler} options={{...options, noResultsMessage: "No selected items" }} label={options?.secondListLabel}></SelectableList>
        </div>
    </div>
}
